import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },
  text: {
    fontSize: 8,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 12,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  columnHeader: {
    width: '15%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '15%',
    padding: 7,
    textAlign: 'center',
    alignItems: 'center'
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

const COLORS = ['#f0f0f0', '#e0e0e0'];

export const DietReportPdf = ({ data }) => {
  console.log('DietReportData', data);

  // Group the data by `uhid`
  const groupedData = data.reduce((acc, item) => {
    const uhid = item?.uhid;
    if (!acc[uhid]) {
      acc[uhid] = [];
    }
    acc[uhid].push(item);
    return acc;
  }, {});

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  const user = JSON.parse(localStorage.getItem('user'));
 
  
  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Diet Management Report">
          <Page style={styles.page} size="A4" orientation="landscape">
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            <View style={styles.row}>
              <Text style={styles.textBold} content="Diet Management Report" />
            </View>

            {/* Header */}
            <View style={styles.row}>
              <Text style={{ ...styles.columnHeader, width: '50px' }} content="Sr No." />
              <Text style={{ ...styles.columnHeader, width: '300px' }} content="Patient Name" />
              <Text style={{ ...styles.columnHeader }} content="Diet Type" />
              <Text style={{ ...styles.columnHeader }} content="Diet Details" />
              <Text style={styles.columnHeader} content="Date" />
              <Text style={{ ...styles.columnHeader }} content="Time" />
            </View>

            {/* Iterate over grouped data */}
            {Object.keys(groupedData).map((uhid, patientIndex) => {
              const patientData = groupedData[uhid];
              const patientName = `${patientData[0]?.patientData?.name_suffix} ${patientData[0]?.patientData?.first_name} ${patientData[0]?.patientData?.last_name}`;
              const patientUhid = `${patientData[0]?.uhid}`;
              const patientAdmNo = `${patientData[0]?.ipd_no}`;
              const patientDoctorName = `${patientData[0]?.doctorsData?.name}`;
              const patientSponsor = `${patientData[0]?.sponsorData?.name}`;
              const patientWard = `${patientData[0]?.wardmasterData?.name}`;
              const patientRoomNo = `${patientData[0]?.roommasterData?.room_no}`;
              const patientBed = `${patientData[0]?.roommasterData?.beds?.[0]?.bed_no}`;
              const patientAdmDate = formatDate(`${patientData[0]?.indoorregisterationData?.date}`);
              const patientNurseStation = `${patientData[0]?.nursemasterData?.name}`;
              // const patientAddDiet = `${patientData[0]}`;
              
              return (
                <View key={patientIndex}>
                  {/* Patient header */}
                  <View style={styles.row}>
                    <Text style={styles.textBold} content={`UHID: ${patientUhid}    Name: ${patientName}    Adm No: ${patientAdmNo}    Doctor Name: ${patientDoctorName}   Sponsor Name: ${patientSponsor}   Ward: ${patientWard}   Room No: ${patientRoomNo}   Bed No: ${patientBed}   Adm. Date: ${patientAdmDate}   Nurse Station: ${patientNurseStation}`} />
                  </View>

                  {/* Patient's diet data */}
                  {patientData.map((item, index) => (
                    <View
                      key={index}
                      style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}
                    >
                      <Text style={{ ...styles.columnContent, width: '50px' }} content={index + 1} />
                      <Text
                        style={{ ...styles.columnContent, width: '300px', textAlign: 'left' }}
                        content={patientName}
                      />
                      <Text style={{ ...styles.columnContent, textAlign: 'left' }} content={item?.diet_type} />
                      <Text style={{ ...styles.columnContent, textAlign: 'left' }} content={item?.diet_detail} />
                      <Text style={styles.columnContent} content={formatDate(item?.date)} />
                      <Text style={styles.columnContent} content={item?.time} />
                    </View>
                  ))}
                </View>
              );
            })}
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};
